import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import {
  Build,
  DirectionsCar,
  DirectionsCarFilled,
  CalendarToday,
  Construction,
  Person,
  Email,
  Phone,
  ArrowForward,
} from "@mui/icons-material";
import carsData from "../pages/cars_datas.json";
import Transmission from "../pages/transmissiondata.json";
import emailjs from "emailjs-com";

const Engine = () => {
  const [selectedPart, setSelectedPart] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedVariant, setSelectedVariant] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [consent, setConsent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [years, setYears] = useState([]);
  const [variants, setVariants] = useState([]);

  useEffect(() => {
    setBrands([]);
    setModels([]);
    setYears([]);
    setVariants([]);
    setSelectedBrand("");
    setSelectedModel("");
    setSelectedYear("");
    setSelectedVariant("");

    if (selectedPart === "Engine") {
      const uniqueBrands = [...new Set(carsData.map((car) => car.brand))];
      setBrands(uniqueBrands);
    } else if (selectedPart === "Transmission") {
      const uniqueBrands = [...new Set(Transmission.map((trans) => trans.brand))];
      setBrands(uniqueBrands);
    }
  }, [selectedPart]);

  useEffect(() => {
    setModels([]);
    setYears([]);
    setVariants([]);
    setSelectedModel("");
    setSelectedYear("");
    setSelectedVariant("");

    if (selectedBrand) {
      const dataSource = selectedPart === "Engine" ? carsData : Transmission;
      const uniqueModels = [...new Set(dataSource.filter((item) => item.brand === selectedBrand).map((item) => item.car))];
      setModels(uniqueModels);
    }
  }, [selectedBrand]);

  useEffect(() => {
    setYears([]);
    setVariants([]);
    setSelectedYear("");
    setSelectedVariant("");

    if (selectedModel) {
      const dataSource = selectedPart === "Engine" ? carsData : Transmission;
      const uniqueYears = [...new Set(dataSource.filter((item) => item.car === selectedModel).map((item) => item.year))];
      setYears(uniqueYears);
    }
  }, [selectedModel]);

  useEffect(() => {
    setVariants([]);
    setSelectedVariant("");

    if (selectedYear) {
      const dataSource = selectedPart === "Engine" ? carsData : Transmission;
      const filteredVariants = dataSource
        .filter((item) => item.car === selectedModel && item.year === selectedYear)
        .map((item) => item.variant);
      setVariants(filteredVariants);
    }
  }, [selectedYear]);

  // const handleSubmit = (event) => {
  //   event.preventDefault();

  //   if (!userName || !userEmail || !userPhone) {
  //     alert("Please fill in all fields.");
  //     return;
  //   }

  //   const formData = {
  //     selectedPart,
  //     selectedBrand,
  //     selectedModel,
  //     selectedYear,
  //     selectedVariant,
  //     userName,
  //     userEmail,
  //     userPhone,
  //     consent: consent ? "Yes" : "No",
  //   };

  //   emailjs
  //     .send("service_xs37ipj", "template_ph7df3a", formData, "TUhvHgQ0Bp4osZuvg")
  //     .then((response) => {
  //       // alert("Email sent successfully!");
  //       console.log("SUCCESS!", response.status, response.text);
  //     })
  //     .catch((err) => {
  //       alert("Failed to send email.");
  //       console.error("FAILED...", err);
  //     });
  // };


  const handleSubmit = async (event) => {
    event.preventDefault();
  
    if (!userName || !userEmail || !userPhone) {
      alert("Please fill in all fields.");
      return;
    }
  
    setIsSubmitting(true);
  
    const formData = {
      selected_part: selectedPart,
      selected_brand: selectedBrand,
      selected_model: selectedModel,
      selected_year: selectedYear,
      selected_variant: selectedVariant,
      user_name: userName,
      user_email: userEmail,
      user_phone: userPhone,
      consent: consent ? "Yes" : "No",
    };
  
    try {
      const response = await emailjs.send(
        "service_xs37ipj",
        "template_ph7df3a",
        formData,
        "TUhvHgQ0Bp4osZuvg"
      );
      console.log("SUCCESS!", response.status, response.text);
      setSubmissionSuccess(true);
    } catch (err) {
      console.error("FAILED...", err);
      alert("Failed to send email. Please try again.");
    }
  
    setIsSubmitting(false);
  };
  return (
    <Container maxWidth="md" sx={{ p: 0 }}>
      <Box
        sx={{
          bgcolor: "white",
          color: "black",
          p: 0,
          borderRadius: 2,
          boxShadow: 3,
          textAlign: "center",
        }}
      >
        {/* <Typography variant="h5" fontWeight="bold" mb={2}>
          Let's find the perfect Used Engine or Transmission for you.
        </Typography> */}
        <Box sx={{ bgcolor: "#f7f7f7", p: 3, borderRadius: 2 }}>
          {/* {/ {/ <Typography variant="h6" fontWeight="bold">FILL UP THE FORM</Typography> /} /} */}
          <Typography variant="h5" fontWeight="bold" mb={4}>
          Get Your Free Quote
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* {/ {/ Part Selection /} /} */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Select Part</InputLabel>
                  <Select
                    startAdornment={<Build color="error" />}
                    value={selectedPart}
                    onChange={(e) => setSelectedPart(e.target.value)}
                    label="Select Part"
                  >
                    <MenuItem value="">Select Part</MenuItem>
                    <MenuItem value="Engine">Engine</MenuItem>
                    <MenuItem value="Transmission">Transmission</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* {/ {/ Brand Selection /} /} */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth disabled={!selectedPart}>
                  <InputLabel>Select Brand</InputLabel>
                  <Select
                    startAdornment={<DirectionsCar color="error" />}
                    value={selectedBrand}
                    onChange={(e) => setSelectedBrand(e.target.value)}
                    label="Select Brand"
                  >
                    <MenuItem value="">Select Brand</MenuItem>
                    {brands.map((brand) => (
                      <MenuItem key={brand} value={brand}>
                        {brand}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* {/ {/ Model Selection /} /} */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth disabled={!selectedBrand}>
                  <InputLabel>Select Model</InputLabel>
                  <Select
                    startAdornment={<DirectionsCarFilled color="error" />}
                    value={selectedModel}
                    onChange={(e) => setSelectedModel(e.target.value)}
                    label="Select Model"
                  >
                    <MenuItem value="">Select Model</MenuItem>
                    {models.map((model) => (
                      <MenuItem key={model} value={model}>
                        {model}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* {/ {/ Year Selection /} /} */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth disabled={!selectedModel}>
                  <InputLabel>Select Year</InputLabel>
                  <Select
                    startAdornment={<CalendarToday color="error" />}
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    label="Select Year"
                  >
                    <MenuItem value="">Select Year</MenuItem>
                    {years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* {/ {/ Variant Selection /} /}
                 */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth disabled={!selectedYear}>
                  <InputLabel>Select Variant</InputLabel>
                  <Select
                    startAdornment={<Construction color="error" />}
                    value={selectedVariant}
                    onChange={(e) => setSelectedVariant(e.target.value)}
                    label="Select Variant"
                  >
                    <MenuItem value="">Select Variant</MenuItem>
                    {variants.map((variant) => (
                      <MenuItem key={variant} value={variant}>
                        {variant}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
  <TextField
    fullWidth
    label="Enter Your Name"
    variant="outlined"
    value={userName}
    onChange={(e) => setUserName(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Person color="error" />
        </InputAdornment>
      ),
    }}
  />
</Grid>

<Grid item xs={12} sm={6}>
  <TextField
    fullWidth
    label="Enter Your Email ID"
    type="email"
    variant="outlined"
    value={userEmail}
    onChange={(e) => setUserEmail(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Email color="error" />
        </InputAdornment>
      ),
    }}
  />
</Grid>

<Grid item xs={12} sm={6}>
  <TextField
    fullWidth
    label="Enter Phone Number"
    type="tel"
    variant="outlined"
    value={userPhone}
    onChange={(e) => setUserPhone(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Phone color="error" />
        </InputAdornment>
      ),
    }}
  />
</Grid>
</Grid>
        <Box mt={2} textAlign="left">
              <FormControlLabel
                control={<Checkbox color="error" />}
                label={
                  <Typography fontSize="12px">
                  By clicking “Submit,” you agree to YND Autoparts’ Terms & Conditions and Privacy Policy. You acknowledge that the information provided may be used to contact you regarding your inquiry.
                  </Typography>
                }
              />
            </Box>
            <Box display="flex" justifyContent="center">
            <Button
  type="submit"
  variant="contained"
  color="error"
  sx={{ mt: 2, py: 1, px: 4 }}
  endIcon={<ArrowForward />}
  disabled={isSubmitting || submissionSuccess}
>
  {submissionSuccess ? "Submitted" : isSubmitting ? "Submitting..." : "SUBMIT"}
</Button>

            </Box>
          </form>
        </Box>
      </Box>
    </Container>
  );
};

export default Engine;